const doc = [({"header":({"loginToConsole":"コンソールにログイン", "CookieLowMessage":"このWebサイトでは、利便性を向上させるためCookieを使用しています。 Cookieの使用に同意する場合はOKをクリックしてください。"}), "news":({"title":"システムからのお知らせ"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;